<!--
 * @Description: 协定服务-导入金额算金额
 * @Date: 2020-07-08 10:54:39
-->
<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="ruleForm"
    >
      <el-form-item>
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="importSettlementAmount"
          :on-success="handleSuccess"
          :on-exceed="uploadExc"
          :on-error="uploadError"
          :on-change="fileChange"
          :on-remove="fileRemove"
          name="file"
          :multiple="false"
          :limit="1"
          :auto-upload="false"
          :data="ruleForm"
          :headers="headers"
        >
          <el-button slot="trigger" type="primary">
            请选择文件
          </el-button>
          <el-button type="text" @click="downLoad">
            下载列表数据
          </el-button>
          <p style="margin:10px 0">
            上传格式为xls或xlsx文件,最大支持20M
          </p>
          <p style="color:red;">
            下载的列表数据除终端结算金额外其他内容请勿修改 否则会上传失败
          </p>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="footer" style="text-align:center">
      <el-button type="primary" @click="confirm" :loading="btLoading">
        确认
      </el-button>
      <el-button @click="close">返回</el-button>
    </div>
  </div>
</template>

<script>
import { protocolService } from '@/api/ajax';
import { getToken } from '@/tools/auth';
import { btLoading } from '@/Mixin/btLoading';
import Config from '@/config/index';
import sanji from '@/Mixin/sanji';

export default {
  mixins: [btLoading, sanji],
  props: {
    projectType: {
      type: Number,
      default: 0
    },
    fenpeiId: {
      type: Number,
      default: 0
    },
    ifRe: {
      type: Boolean,
      default: false
    },
    tableSearchQuery: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      importSettlementAmount: protocolService.importSettlementAmount,
      hasFile: false,
      headers: {},
      ruleForm: {
        projectId: this.$route.query.id,
        secondaryConfirmation: 0
      },
      rules: {
        taskDate: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        finishSum: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ]
      },
      searchQuery: {}
    };
  },
  methods: {
    // 修改file state，方便调用upload submit再次提交
    changeFileState() {
      const upload = this.$refs.upload;
      upload.uploadFiles.length && (upload.uploadFiles[0].status = 'ready');
    },
    handleSuccess(response) {
      const upload = this.$refs.upload;
      if (response.status == 1 && response.code == 1) {
        this.$notify({
          title: '成功',
          message: response.message,
          type: 'success'
        });
        upload.clearFiles();
        this.$emit('success');
        this.close();
      } else if (response.status == 1 && response.code == 2) {
        this.$confirm(response.message, '提示', {
          confirmButtonText: '提交',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.ruleForm.secondaryConfirmation = 1;
          this.changeFileState();
          upload.submit();
        });
      } else {
        this.$notify({
          title: '错误',
          message: response.message,
          type: 'error'
        });
        upload.clearFiles();
      }
      this.SET_BTLOADING(false);
    },
    confirm() {
      //确定上传
      if (!this.hasFile) {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        });
        return false;
      }
      this.SET_BTLOADING(true);
      this.$refs.upload.submit();
    },
    downLoad() {
      let queryString = this.$querystring.stringify({
        type: this.$store.state.dataAnalysis.projectDetail.type,
        projectId: this.$route.query.id,
        ...this.tableSearchQuery
      });
      this.$downloadFile(
        protocolService.agreementServiceDownloadTheList + `?${queryString}`,
        true
      );
    },
    close() {
      this.$xrkDialog.remove();
    },
    uploadExc() {
      this.$notify({
        title: '失败',
        message: '只能上传一个文件，如若修改请手动删除当前上传文件',
        type: 'error'
      });
    },
    uploadError() {
      this.SET_BTLOADING(false);
    },
    fileChange(file, fileList) {
      if (fileList.length) {
        this.hasFile = true;
      } else {
        this.hasFile = false;
      }
    },
    fileRemove() {
      this.hasFile = false;
    }
  },
  created() {
    this.headers[Config.token] = getToken();
  }
};
</script>
